const profile = {
  title: "Meu perfil",
  premiumBtn: "Ser Membro",
  orderInfoTitle: "Informações sobre permissão de conta",
  tableProduct: "Produto",
  tableStatus: "Estado",
  tablePermissionDate: "Data de permissão",
  tableValidPeriod: "Período de validade",
  validStauts: "Válido",
  expiredStauts: "Expirado",
  noData: "Sem dados",
};

export default profile;
